import { Injectable } from '@angular/core';
import axios from 'axios';
import { AuthService } from '@services/auth/auth.service';
import { environment, BASE_URL_SERVICIOS_USUARIOS } from "@env/environment";
import { Router } from '@angular/router';
import { ToolsService } from '@services/varios/tools.service';
import { Perfil } from 'src/app/common/interfaces/perfil.interface';
import { PerfilUsuario } from 'src/app/common/interfaces/perfil-usuario.interface';

@Injectable({
  providedIn: 'root'
})

export class PerfilesService {

  constructor(private readonly authService: AuthService, private readonly router: Router, private readonly toolsService: ToolsService) { }

  public async getPerfilesService(): Promise<Perfil[]> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getPerfilesByIdSistema?idSistema=' + environment.idSistema;

    return await axios.get(BASE_URL, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      if (resp.data.respuesta == 'ok') {
        return resp.data.perfiles;
      } else {
        let rs: Perfil[] = {} as Perfil[];
        return rs;
      }
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }

  public async getPerfilesUsuario(idUsuario: string): Promise<PerfilUsuario[]> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getPerfilesUsuario?idSistema=' + environment.idSistema + '&idUsuario=' + idUsuario;;

    return await axios.get(BASE_URL, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      if (resp.data.respuesta == 'ok') {
        return resp.data.perfiles;
      } else {
        let rs: Perfil[] = {} as Perfil[];
        return rs;
      }
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }

  public async addOrUpdatePerfil(perfil: Perfil): Promise<Perfil> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/addOrUpdatePerfil';

    return await axios.post(BASE_URL, perfil, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      if (resp.data.respuesta == 'ok') {
        return resp.data.perfil;
      } else {
        let rs: Perfil[] = {} as Perfil[];
        return rs;
      }
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }

  public async deletePerfil(perfil: Perfil): Promise<string> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/deletePerfil';

    return await axios.post(BASE_URL, perfil, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      return resp.data;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }
}
